import { useUserSessionInit } from "src/hooks";
import {
  PageHeader,
  PageContainer,
  PageFormContainer,
} from "src/components/Page";
import type { FormLayout } from "./FormLayout.types";
import FormFooter from "./FormFooter";
import FormPageHeading from "./FormPageHeading";
import { useEffect } from "react";
import { logPageView } from "src/utils";

export default ({
  title,
  subtitle,
  headerTitle,
  stepIndex,
  footerTitle,
  clickHandler,
  cancelHandler,
  children,
  isLoading,
}: FormLayout) => {
  useUserSessionInit();

  useEffect(() => {
    document.title = `${headerTitle} - PorchPass`;
    logPageView();
  }, []);

  return (
    <>
      <PageHeader stepTitle={headerTitle} stepIndex={stepIndex} />
      <PageContainer>
        <PageFormContainer>
          {/* Only md: needs bottom padding (room for the fixed footer). Avoid a
              base pb-* here: @porchpass/ui's prebuilt utilities load after ours
              and would override the md: value. */}
          <div className="w-full max-w-[768px] px-8 pt-8 md:pb-[144px]">
            <fieldset className="flex w-full flex-col items-center">
              <FormPageHeading title={title} subtitle={subtitle} />
              {children}
            </fieldset>
          </div>
          {footerTitle && (
            <FormFooter
              isLoading={isLoading}
              footerTitle={footerTitle}
              clickHandler={clickHandler}
              cancelHandler={cancelHandler}
            />
          )}
        </PageFormContainer>
      </PageContainer>
    </>
  );
};
